'use client';

import { Server, Shield, Clock, Wrench, HardDrive, Database } from 'lucide-react';
import Link from 'next/link';

export default function NASServices() {
  const nasServices = [
    {
      id: 1,
      title: 'NAS & Sauvegarde',
      description: 'Solutions de stockage sécurisé pour particuliers et entreprises. Installation, configuration et maintenance.',
      icon: Server,
      link: '/services#nas'
    },
    {
      id: 2,
      title: 'Configuration sur mesure',
      description: 'Configuration personnalisée de votre NAS selon vos besoins spécifiques en stockage et sécurité.',
      icon: Wrench,
      link: '/services#configuration'
    },
    {
      id: 3,
      title: 'Sécurité des données',
      description: 'Protection avancée de vos données avec solutions de sauvegarde automatique et cryptage.',
      icon: Shield,
      link: '/services#security'
    },
    {
      id: 4,
      title: 'Stockage évolutif',
      description: 'Solutions de stockage adaptables à vos besoins croissants, de quelques Go à plusieurs To.',
      icon: HardDrive,
      link: '/services#storage'
    },
    {
      id: 5,
      title: 'Maintenance & Support',
      description: 'Support technique continu et maintenance préventive pour garantir la disponibilité de vos données.',
      icon: Clock,
      link: '/services#maintenance'
    },
    {
      id: 6,
      title: 'Migration de données',
      description: 'Transfert sécurisé de vos données depuis vos anciens systèmes vers votre nouveau NAS.',
      icon: Database,
      link: '/services#migration'
    },
  ];

  return (
    <section id="services" className="py-12 sm:py-16 lg:py-20 bg-linear-to-br from-gray-50 to-[#23994F]/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div className="mb-8 sm:mb-12 lg:mb-16 fade-in text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            Solutions NAS & Stockage
          </h2>
          <p className="text-base sm:text-lg text-gray-600">
            Protégez et centralisez vos données avec nos solutions de stockage professionnel
          </p>
          <p className="mt-2 text-sm text-gray-500">
            Pour particuliers et entreprises - Installation et configuration sur mesure
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {nasServices.map((service, idx) => {
            const Icon = service.icon;

            return (
              <Link
                key={service.id}
                href={service.link}
                className="fade-in bg-white rounded-xl sm:rounded-2xl border-2 border-[#23994F]/20 overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group transform hover:scale-102 hover:-translate-y-1"
                style={{ animationDelay: `${idx * 0.1}s` }}
              >
                <div className="p-6 sm:p-8">
                  <div className="w-14 h-14 sm:w-16 sm:h-16 bg-linear-to-br from-[#23994F]/15 to-blue-400/15 rounded-full flex items-center justify-center mb-4 sm:mb-6 group-hover:from-[#23994F]/25 group-hover:to-blue-400/25 transition-all duration-300 transform group-hover:scale-105">
                    <Icon size={28} className="sm:w-8 sm:h-8 text-[#23994F] transition-transform duration-300 group-hover:rotate-12" />
                  </div>

                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3 group-hover:text-[#23994F] transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                    {service.description}
                  </p>
                </div>

                <div className="bg-linear-to-r from-[#23994F] to-[#1a7840] px-6 py-3 flex items-center justify-between group-hover:from-[#1a7840] group-hover:to-[#23994F] transition-all">
                  <span className="text-white font-semibold text-sm sm:text-base">En savoir plus</span>
                  <svg
                    className="w-5 h-5 text-white transform group-hover:translate-x-1 transition-transform"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="mt-8 sm:mt-12 text-center fade-in" style={{ animationDelay: '0.6s' }}>
          <Link
            href="/services"
            className="inline-flex items-center gap-2 px-6 sm:px-8 py-3 sm:py-4 bg-[#23994F] text-white font-bold text-base sm:text-lg rounded-lg hover:bg-[#1a7840] transition-all duration-300 hover:shadow-xl transform hover:scale-105"
          >
            Voir tous nos services
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
}
